(ns dre.pages.shared.events
  (:require 
   [clojure.string :as str]
   [clojure.walk :as walk]
   [day8.re-frame.tracing :refer-macros [fn-traced]]
   [dre.network :as-alias network]
   [dre.app.router :as-alias router]
   [dre.util :refer [in?]]
   [dre.shared.interface.search.blunt :as blunt]
   [re-frame.core :as rf]
   [superstructor.re-frame.fetch-fx :as-alias fetch-fx]))

(def db-path :shared)

(defn query->labels
  [search-query]
  (let [texts (volatile! [])]
    (walk/postwalk
     (fn [x]
       (if (map? x)
         (let [text (case (:pill/type x)
                      :term
                      (str/join
                       " "
                       ((juxt :pill/canonical-label
                              :pill/label)
                        x))
                      :text (:pill/query x)
                      (:pill/label x))
               _ (.log js/console x)]
           (when text (vswap! texts conj text))
           x)
         x))
     search-query)
    @texts))

;; events

(rf/reg-event-fx
 ::init
 [(rf/path db-path) rf/trim-v]
 (fn-traced
  [_ _]
  {:dispatch [::fetch-shared]}))

(rf/reg-event-fx
 ::fetch-shared
 [(rf/path db-path) rf/trim-v]
 (fn-traced
  [{db :db} [_]]
  {:db (assoc db :state :loading)
   ::network/request [{:endpoint :app/notifications}
                      {:on-success [::success-fetch-shared]
                       :on-failure [::failure-fetch-shared]}]}))
(rf/reg-event-fx
 ::success-fetch-shared
 [(rf/path db-path) rf/trim-v]
 (fn-traced
  [{db :db} [{:keys [::fetch-fx/response]}]]
  (let [notifications (:body response) 
        module nil
        notification-filter (fn [{:keys [:modules]}]
                              (if (= module :regintel)
                                (in? modules "regintel")
                                (not (in? modules "regintel"))))
        notifications (if (fn? notification-filter)
                        (filter notification-filter notifications)
                        notifications)
        grouped (group-by :source notifications) 
        shared-queries (get grouped "shared-query")]
    {:db (-> db
           (assoc-in [:data :shared] shared-queries)
           (assoc :state :success))})))

(rf/reg-event-fx
 ::failure-fetch-shared
 [(rf/path db-path) rf/trim-v]
 (fn-traced
  [{db :db} [{:keys [::fetch-fx/response] :as opts}]]
  {:db (-> db
           (assoc :state :failure)
           (assoc :data nil))
   :dispatch-n [[:dre.network/default-failure opts]]}))

(rf/reg-event-fx
 ::set-shared-filter
 [(rf/path db-path) rf/trim-v]
 (fn-traced
  [{db :db} [filter]]
  {:db (-> db
           (assoc-in [:data :shared-filter] filter))}))

;;subscriptions

(rf/reg-sub
 ::state
 (fn [db _]
   (db-path db)))

(rf/reg-sub
 ::shared-filter
 :<- [::state]
 (fn [state _]
   (let [data (get-in state [:data :shared-filter] nil)]
     data)))

(rf/reg-sub
 ::shared
 :<- [::state]
 :<- [::shared-filter]
 (fn [[state shared-filter] _]
   (let [data (get-in state [:data :shared])
         data (if (or (not shared-filter) (str/blank? shared-filter))
                data
                (filter (fn [{:keys [:description :object-id]}]
                          (let [parsed-object-id (str/split object-id "&")
                                query-params (if (= 1 (count parsed-object-id))
                                               {:query object-id}
                                               {:query (last parsed-object-id) :order (first parsed-object-id)})
                                search-query (blunt/parse (:query query-params))
                                labels (query->labels search-query)
                                label-str (str/join labels) 
                                label-match? (or (str/includes? (str/lower-case (or description "")) (-> (or shared-filter "")
                                                                                                 (str/trim)
                                                                                                 (str/lower-case)))
                                                 (str/includes? (str/lower-case (or label-str "")) (-> (or shared-filter "")
                                                                                                 (str/trim)
                                                                                                 (str/lower-case))))]
                            label-match?)) 
                        data))]
     data)))

(rf/reg-sub
 ::loading?
 :<- [::state]
 (fn [state _]
   (let [data (get state :state nil)]
     (= :loading data))))